import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9ae9b76c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "error-occurred"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"error-svg\" data-v-9ae9b76c><svg height=\"70\" viewBox=\"0 0 32 32\" width=\"70\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" data-v-9ae9b76c><g data-v-9ae9b76c><g id=\"Error_1_\" data-v-9ae9b76c><g id=\"Error\" data-v-9ae9b76c><circle cx=\"16\" cy=\"16\" id=\"BG\" r=\"16\" style=\"fill:#D72828;\" data-v-9ae9b76c></circle><path d=\"M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z\" id=\"Exclamatory_x5F_Sign\" style=\"fill:#E6E6E6;\" data-v-9ae9b76c></path></g></g></g></svg></div>", 1);
const _hoisted_3 = {
  class: "error-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", {
    class: "error-wrapper",
    style: _normalizeStyle({
      height: $props.wrapperHeight + 'px'
    })
  }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, _toDisplayString($props.text), 1), _createVNode(_component_app_button, {
    onClick: $options.handleRetry,
    v2: "",
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode("Retry")]),
    _: 1
  }, 8, ["onClick", "loading"])])], 4);
}